<template>
    <div class="menu" @mouseenter="focusOnSelectedField(selectedField)" @mouseleave="focusOnSelectedField(selectedField)">
        <div>
            <div class="d-flex justify-content-between m-2">
                <div class="font-weight-bold">
                    {{ $t('AppFieldsAsideMenu.Talhões') }}
                </div>
                <Badge v-if="activeFilters > 0" :value="activeFilters"
                       v-tooltip.bottom="$t('AppFieldsAsideMenu.Filtros ativos')"/>
            </div>
            <div class="filter-bar p-2 mr-1 mb-1 d-flex flex-column">
<!--TODO desabilitado momentaneamente até consertar query                -->
<!--                <MultiSelect ref="multiselect" v-model="operationTypeFilter" :options="availableOperationTypes" optionLabel="label"-->
<!--                             dataKey="name" :placeholder="$t('AppFieldsAsideMenu.Última operação realizada')"/>-->
                <InputText v-model="nameFilter" :placeholder="$t('AppFieldsAsideMenu.Pesquisar talhão')" class="mt-2"/>
            </div>
        </div>
        <div class="aside-menu">
            <div v-if="!filteredFields.length && !loading" class="no-field-warning mt-3 mx-3">
                <div class="font-weight-bold mb-1">
                    {{ $t('AppFieldsAsideMenu.Nenhum talhão encontrado') }}
                </div>
                <div class="no-field-warning-description">
                    {{ $t('AppFieldsAsideMenu.Modifique o filtro para realizar nova busca') }}
                </div>
            </div>
            <div v-else v-for="field in filteredFields" class="d-flex p-1 field" :id="field.id" :key="field.id"
                 :class="{'selected': isSelectedField(field)}" @click="selectField(field)">
                <div class="font-weight-bold kt-font-md field-name">
                    {{ field.name }}
                </div>
                <div class="d-flex flex-column align-items-center field-polygon">
                    <canvas :id="`${field.id}-polygon`" width=100 height=100 :ref="`${field.id}-canvas`"
                            class="polygon"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as jsts from 'jsts';
import hexToRgb from "@/mixins/ColorMixin";

import MultiSelect from 'primevue/multiselect';
import InputText from 'primevue/inputtext';
import Tooltip from "primevue/tooltip";
import Badge from 'primevue/badge';

export default {
    mixins: [hexToRgb],
    data() {
        return {
            nameFilter: null,
            operationTypeFilter: [],
            MOCK_POLYGON: 'POLYGON((-51.325378 -16.975368, -51.075439 -16.975368, -51.075439 -16.744058, -51.325378 -16.744058, -51.325378 -16.975368))'
        }
    },
    props: {
        fields: {
            type: Array,
            default() {
                return [];
            }
        },
        selectedField: {
            type: Object
        },
        loading: {
            type: Boolean
        }
    },
    methods: {
        drawPolygon(field) {
            let noCoordinates = !field.coordinates;
            let fieldCoordinates = field.coordinates;
            if (noCoordinates) {
                fieldCoordinates = this.MOCK_POLYGON;
            }

            let canvas = document.getElementById(`${field.id}-polygon`);
            let ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            let polygon = this.buildPolygonFromCoordinates(fieldCoordinates)
            let myPoints = []

            polygon._shell.getCoordinates().forEach(coord => {
                myPoints.push([parseFloat(coord.x), parseFloat(coord.y)]);
            })

            let minX, minY, maxX, maxY;
            myPoints.forEach((p, i) => {
                if (i === 0) {
                    minX = maxX = p[0];
                    minY = maxY = p[1];
                } else {
                    minX = Math.min(p[0], minX);
                    minY = Math.min(p[1], minY);
                    maxX = Math.max(p[0], maxX);
                    maxY = Math.max(p[1], maxY);
                }
            });

            const mapWidth = maxX - minX;
            const mapHeight = maxY - minY;
            const mapCenterX = (maxX + minX) / 2;
            const mapCenterY = (maxY + minY) / 2;

            const scale = Math.min((canvas.width - 5) / mapWidth, (canvas.height - 5) / mapHeight);

            ctx.setTransform(1, 0, 0, -1, -1, canvas.height);
            ctx.beginPath();

            let hasOperation = this.formatPolygon(field, ctx, noCoordinates);

            myPoints.forEach(p => {
                ctx.lineTo(
                    (p[0] - mapCenterX) * scale + canvas.width / 2,
                    (p[1] - mapCenterY) * scale + canvas.height / 2
                );
            });

            if (hasOperation) {
                ctx.fill();
            }
            ctx.stroke();
        },
        formatPolygon(field, ctx, noCoordinates) {
            if (noCoordinates) {
                ctx.setLineDash([10, 6])
            }

            if (field.operationType.name === 'NONE') {
                return false;
            }

            let color = this.hexToRgb(field.operationType.color);

            ctx.strokeStyle = `rgb(${color[0]} ${color[1]} ${color[2]} / 100%)`;
            ctx.fillStyle = `rgb(${color[0]} ${color[1]} ${color[2]} / 50%)`;
            return true;
        },
        buildPolygonFromCoordinates(wtkString) {
            let reader = new jsts.io.WKTReader();
            return reader.read(wtkString);
        },
        selectField(field) {
            this.$emit('selectField', field, true);
        },
        isSelectedField(field) {
            return field.id === this.selectedField?.id
        },
        focusOnSelectedField(field) {
            if (!field) {
                return;
            }

            let fieldDiv = document.getElementById(field.id);
            if (fieldDiv) {
                fieldDiv.scrollIntoView({behavior: 'smooth'});
            }
            this.$refs.multiselect?.hide();
        }
    },
    watch: {
        filteredFields: function () {
            if (this.filteredFields.length) {
                setTimeout(() => this.filteredFields.forEach(field => this.drawPolygon(field)), 5);
            }
        }
    },
    computed: {
        availableOperationTypes() {
            return this.fields.filter((value, index, fields) => {
                return fields.findIndex(v => v.operationType.name === value.operationType.name) === index;
            }).map((x) => x.operationType).sort((a, b) => a.group - b.group);
        },
        activeFilters: function () {
            if (this.nameFilter && this.operationTypeFilter.length > 0) {
                return 2;
            }

            return (this.nameFilter || this.operationTypeFilter.length > 0) ? 1 : 0;
        },
        filteredFields: function () {
            if (!this.nameFilter && !this.operationTypeFilter.length) {
                return this.fields;
            }

            let filteredData;
            if (this.nameFilter) {
                filteredData = this.fields.filter(field => field.name.toLowerCase().includes(this.nameFilter.toLowerCase()));
            }

            filteredData ??= this.fields;
            if (this.operationTypeFilter.length) {
                filteredData = filteredData.filter(field => this.operationTypeFilter.some(opType => field.operationType.name === opType.name));
            }

            return filteredData;
        }
    },
    directives: {
        'tooltip': Tooltip
    },
    components: {Badge, InputText, Tooltip, MultiSelect}
}
</script>

<style scoped>
.menu {
    background-color: #fff;
}

.aside-menu {
    height: calc(100vh - 115px);
    overflow-y: auto;
    overflow-x: hidden;
}

.no-field-warning {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.no-field-warning-description {
    display: none;
}

.menu:hover {
    .aside-menu {
        height: calc(100vh - 210px);
    }

    .filter-bar {
        display: flex !important;
    }

    .no-field-warning-description {
        display: flex;
    }
}

.filter-bar {
    display: none !important;
}

.filter-bar .p-inputtext {
    padding-left: 1.5rem !important;
}

.aside-menu .field {
    flex-direction: column;
}

.aside-menu:hover .field, .menu:hover .field {
    flex-direction: row-reverse;
    justify-content: flex-end;
    align-items: center;

    .field-name {
        margin-left: 1rem;
    }

    .field-polygon {
        margin-left: 1rem;
    }
}

.polygon {
    max-width: 50px;
    max-height: 50px;
}

.field {
    cursor: pointer;
    border-bottom: 1px solid rgba(158, 155, 155, 0.5);
}

.selected {
    background-color: rgba(187, 224, 255, 0.65);
    border-bottom: 3px solid rgba(173, 218, 255, 1);
}

.field:hover {
    background-color: rgba(179, 179, 179, 0.2);
}

.aside-menu::-webkit-scrollbar {
    width: 6px;
}

.aside-menu::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(98, 95, 95, 0.8);
}

.aside-menu::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 2px rgba(98, 95, 95, 0.7);
}

.aside-menu::-webkit-scrollbar-thumb:hover {
    -webkit-box-shadow: inset 0 0 5px rgba(98, 95, 95, 0.7);
}
</style>
